import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FcMultipleDevices, FcManager, FcServices, FcViewDetails, FcRedo } from "react-icons/fc";
import { TbCreditCardPay } from "react-icons/tb";
import Logo from "../images/logo.png";
import { useAuth } from "../Context/AuthUser";
import { Icons } from "../front/components/Icons";
import axiosClient from "../front/axiosClient";
const baseURL = process.env.REACT_APP_API_BASE_URL;

const SideMenu = () => {
    const { user, avatar } = useAuth();
    const [sidebar, setSidebar] = useState(false);
    const [profile, setProfile] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const fetchUser = async () => {
        if (!user?.id) return;

        try {
            const response = await axiosClient.get(`/auth/profile.php`);
            setProfile(response.data.data[0]);
        } catch (err) {
            setError("Whoops, something went wrong!");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchUser();
    }, []);
    const toggleSidebar = () => {
        setSidebar(prev => !prev);
    };

    const closeSidebar = () => {
        setSidebar(false);
    };

    return (
        <>
            <div className={`sidebar ${sidebar ? "open" : ""}`}>
                <div className="sidebar-logo">
                    <img className="logo" src={Logo} alt="logo" />
                </div>
                <div className="sidebar-profile">
                    <Link to="/profile" onClick={closeSidebar}>
                        <img className="profile" src={profile.profile_image
                            ? `${baseURL}/auth/uploads/profiles/${profile.profile_image}`
                            : avatar} alt="profile" style={{ height: '40px', objectFit: 'cover', borderRadius: '50px' }} />
                        <p><strong>{profile?.name}</strong></p>
                    </Link>
                </div>
                <ul className="sidebar-menu">
                    {(user?.role === "admin" || user?.role === "barber") && (
                        <li className="menu-item">
                            <FcMultipleDevices className="icon" />
                            <Link className="item-link" to="/dashboard" onClick={closeSidebar}>
                                Dashboard
                            </Link>
                        </li>
                    )}

                    {user?.role === "admin" && (
                        <li className="menu-item">
                            <FcManager className="icon" />
                            <Link className="item-link" to="/barbers" onClick={closeSidebar}>
                                Barbers
                            </Link>
                        </li>
                    )}
                    {(user?.role === "admin" || user?.role === "barber") && (
                        <li className="menu-item">
                            <Icons.Users className="icon" />
                            <Link className="item-link" to="/staff" onClick={closeSidebar}>
                                Staff
                            </Link>
                        </li>
                    )}
                    {(user?.role === "admin" || user?.role === "barber") && (
                        <li className="menu-item">
                            <FcServices className="icon" />
                            <Link className="item-link" to="/services" onClick={closeSidebar}>
                                Services
                            </Link>
                        </li>
                    )}

                    {user?.role === "admin" && (
                        <li className="menu-item">
                            <FcManager className="icon" />
                            <Link className="item-link" to="/customers" onClick={closeSidebar}>
                                Customers
                            </Link>
                        </li>
                    )}

                    {/* {(user?.role === "admin" || user?.role === "barber") && ( */}
                    <li className="menu-item">
                        <Icons.colorCalendar className="icon" />
                        <Link className="item-link" to="/bookings" onClick={closeSidebar}>
                            Bookings
                        </Link>
                    </li>
                    {/* )} */}

                    {(user?.role === "admin" || user?.role === "barber") && (
                        <li className="menu-item">
                            <Icons.review className="icon" />
                            <Link className="item-link" to="/view-reviews/" onClick={closeSidebar}>
                                View re-views
                            </Link>
                        </li>
                    )}
                    {(user?.role === "admin" || user?.role === "customer") && (
                        <li className="menu-item">
                            <Icons.list className="icon" />
                            <Link className="item-link" to="/view-barbers" onClick={closeSidebar}>
                                All Barbers
                            </Link>
                        </li>
                    )}
                    {(user?.role === "admin" || user?.role === "barber") && (

                        <li className="menu-item">
                            <TbCreditCardPay className="icon" />
                            <Link className="item-link" to="/payments/" onClick={closeSidebar}>
                                Payments
                            </Link>
                        </li>
                    )}
                    <li className="menu-item">
                        <Icons.Phone className="icon" />
                        <a href="tel:+918552857511" className="item-link">Help</a>
                    </li>
                    <li className="menu-item">
                        <FcRedo className="icon" />
                        <Link className="item-link" to="/logout" onClick={closeSidebar}>
                            Logout
                        </Link>
                    </li>
                </ul>

            </div>

            {user?.id && (
                <>
                    {/* Mobile hamburger */}
                    <div className={`sidebar-menu-icon ${sidebar ? "open" : ""}`} onClick={toggleSidebar}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </>

            )}
            {/* Backdrop (mobile only) */}
            {sidebar && <div className="sidebar-backdrop" onClick={closeSidebar}></div>}
        </>
    );
};

export default SideMenu;
